import { useQuery } from 'react-query';
import axios from 'axios';
import { Brand } from '../../types/main';
const API_URL = process.env.REACT_APP_API_URL;

const useSettingBrands = () => {
  const { isLoading, error, data, refetch } = useQuery({
    queryKey: ['brands'],
    queryFn: async (): Promise<Brand[]> => {
      const response = await axios.get(`${API_URL}/brands/global`);
      return response.data;
    },
  });

  return {
    isLoading,
    error,
    brands: data || [],
    refetch,
  };
};

export default useSettingBrands;
